import ISO6391 from 'iso-639-1';

export const LANGUAGES_LIST = {
    'zh-HK': {
        name: 'Chinese (Hong Kong)',
        nativeName: '漢語'
    },
    'sr': {
        name: 'Serbian',
        nativeName: 'Srpski jezik'
    }
};

export const getNativeLanguageName = (lang) => {
    const isoName = ISO6391.getNativeName(lang);
    if (isoName !== '') return isoName;
    return LANGUAGES_LIST[lang]?.nativeName || '';
};
